import { Action } from '@ngrx/store';
import { HomeError } from 'src/commons/interfaces/screens.interface';
import { IHome, IFormRequestInt, IFormRequestExt, IFormRequestCG } from '../../../commons';

export enum HomeActionTypes {
  LoadUserIntState = '[Home] Load My Request Internal State',
  LoadUserIntStateSuccess = '[Home] Load My Request Internal Success',

  LoadUserExtState = '[Home] Load My Request External State',
  LoadUserExtStateSuccess = '[Home] Load My Request External Success',

  LoadHomeStateInit = '[Home] Load Home State Initial',
  LoadHomeStateFail = '[Home] Load Home State Fail',
  HomeScreenErrorReset = '[Home] Home Screen Error Reset',

  LoadFormCCExceptDraftState = '[Home] Load FormCCExceptDraft State',
  LoadFormCCPendingApprovalState = '[Home] Load FormCC Pending Approval State',
  LoadFormCCApprovedState = '[Home] Load FormCC Approved State',
  LoadFormCCExceptDraftStateSuccess = '[Home] Load FormCCExceptDraft State Success',
  LoadFormCCPendingApprovalStateSuccess = '[Home] Load FormCC Pending Approval State Success',
  LoadFormCCApprovedStateSuccess = '[Home] Load FormCC Approved State Success',

  LoadFormMGExceptDraftState = '[Home] Load FormMGExceptDraft State',
  LoadFormMGPendingApprovalState = '[Home] Load FormMG Pending Approval State',
  LoadFormMGApprovedState = '[Home] Load FormMG Approved State',
  LoadFormMGExceptDraftStateSuccess = '[Home] Load FormMGExceptDraft State Success',
  LoadFormMGPendingApprovalStateSuccess = '[Home] Load FormMG Pending Approval State Success',
  LoadFormMGApprovedStateSuccess = '[Home] Load FormMG Approved State Success',

  LoadFormCGExceptDraftState = '[Home] Load FormCGExceptDraft State',
  LoadFormCGPendingApprovalState = '[Home] Load FormCG Pending Approval State',
  LoadFormCGApprovedState = '[Home] Load FormCG Approved State',
  LoadFormCGExceptDraftStateSuccess = '[Home] Load FormCGExceptDraft State Success',
  LoadFormCGPendingApprovalStateSuccess = '[Home] Load FormCG Pending Approval State Success',
  LoadFormCGApprovedStateSuccess = '[Home] Load FormCG Approved State Success',

  LoadFormESExceptDraftState = '[Home] Load FormESExceptDraft State',
  LoadFormESPendingApprovalState = '[Home] Load FormES Pending Approval State',
  LoadFormESApprovedState = '[Home] Load FormES Approved State',
  LoadFormESExceptDraftStateSuccess = '[Home] Load FormESExceptDraft State Success',
  LoadFormESPendingApprovalStateSuccess = '[Home] Load FormES Pending Approval State Success',
  LoadFormESApprovedStateSuccess = '[Home] Load FormES Approved State Success',

  LoadFormPPExceptDraftState = '[Home] Load FormPPExceptDraft State',
  LoadFormPPPendingApprovalState = '[Home] Load FormPP Pending Approval State',
  LoadFormPPApprovedState = '[Home] Load FormPP Approved State',
  LoadFormPPExceptDraftStateSuccess = '[Home] Load FormPPExceptDraft State Success',
  LoadFormPPPendingApprovalStateSuccess = '[Home] Load FormPP Pending Approval State Success',
  LoadFormPPApprovedStateSuccess = '[Home] Load FormPP Approved State Success',

}

export class LoadUserIntState implements Action {
  readonly type = HomeActionTypes.LoadUserIntState;
}

export class LoadUserIntStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadUserIntStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}

export class LoadUserExtState implements Action {
  readonly type = HomeActionTypes.LoadUserExtState;
}

export class LoadUserExtStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadUserExtStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

export class LoadHomeStateInit implements Action {
  readonly type = HomeActionTypes.LoadHomeStateInit;
}

export class LoadHomeStateFail implements Action {
  readonly type = HomeActionTypes.LoadHomeStateFail;
  constructor(public payload: HomeError) { }
}

// FormCC
export class LoadFormCCExceptDraftState implements Action {
  readonly type = HomeActionTypes.LoadFormCCExceptDraftState;
}

export class LoadFormCCExceptDraftStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCCExceptDraftStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}

export class LoadFormCCPendingApprovalState implements Action {
  readonly type = HomeActionTypes.LoadFormCCPendingApprovalState;
}

export class LoadFormCCPendingApprovalStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCCPendingApprovalStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}
export class LoadFormCCApprovedState implements Action {
  readonly type = HomeActionTypes.LoadFormCCApprovedState;
}

export class LoadFormCCApprovedStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCCApprovedStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}

// FormMG
export class LoadFormMGExceptDraftState implements Action {
  readonly type = HomeActionTypes.LoadFormMGExceptDraftState;
}

export class LoadFormMGExceptDraftStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormMGExceptDraftStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}

export class LoadFormMGPendingApprovalState implements Action {
  readonly type = HomeActionTypes.LoadFormMGPendingApprovalState;
}

export class LoadFormMGPendingApprovalStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormMGPendingApprovalStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}
export class LoadFormMGApprovedState implements Action {
  readonly type = HomeActionTypes.LoadFormMGApprovedState;
}

export class LoadFormMGApprovedStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormMGApprovedStateSuccess;
  constructor(public payload: IFormRequestInt) { }
}

// FormCG
export class LoadFormCGExceptDraftState implements Action {
  readonly type = HomeActionTypes.LoadFormCGExceptDraftState;
}

export class LoadFormCGExceptDraftStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCGExceptDraftStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

export class LoadFormCGPendingApprovalState implements Action {
  readonly type = HomeActionTypes.LoadFormCGPendingApprovalState;
}

export class LoadFormCGPendingApprovalStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCGPendingApprovalStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}
export class LoadFormCGApprovedState implements Action {
  readonly type = HomeActionTypes.LoadFormCGApprovedState;
}

export class LoadFormCGApprovedStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormCGApprovedStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

// FormES
export class LoadFormESExceptDraftState implements Action {
  readonly type = HomeActionTypes.LoadFormESExceptDraftState;
}

export class LoadFormESExceptDraftStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormESExceptDraftStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

export class LoadFormESPendingApprovalState implements Action {
  readonly type = HomeActionTypes.LoadFormESPendingApprovalState;
}

export class LoadFormESPendingApprovalStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormESPendingApprovalStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}
export class LoadFormESApprovedState implements Action {
  readonly type = HomeActionTypes.LoadFormESApprovedState;
}

export class LoadFormESApprovedStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormESApprovedStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

// FormPP
export class LoadFormPPExceptDraftState implements Action {
  readonly type = HomeActionTypes.LoadFormPPExceptDraftState;
}

export class LoadFormPPExceptDraftStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormPPExceptDraftStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

export class LoadFormPPPendingApprovalState implements Action {
  readonly type = HomeActionTypes.LoadFormPPPendingApprovalState;
}

export class LoadFormPPPendingApprovalStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormPPPendingApprovalStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}
export class LoadFormPPApprovedState implements Action {
  readonly type = HomeActionTypes.LoadFormPPApprovedState;
}

export class LoadFormPPApprovedStateSuccess implements Action {
  readonly type = HomeActionTypes.LoadFormPPApprovedStateSuccess;
  constructor(public payload: IFormRequestExt) { }
}

export class HomeScreenErrorReset implements Action {
  readonly type = HomeActionTypes.HomeScreenErrorReset;
}
export type HomeActions =
  LoadUserIntState
  | LoadUserIntStateSuccess

  | LoadUserExtState
  | LoadUserExtStateSuccess

  | LoadHomeStateInit
  | LoadHomeStateFail
  | HomeScreenErrorReset

  | LoadFormCCExceptDraftState
  | LoadFormCCExceptDraftStateSuccess
  | LoadFormCCPendingApprovalState
  | LoadFormCCPendingApprovalStateSuccess
  | LoadFormCCApprovedState
  | LoadFormCCApprovedStateSuccess

  | LoadFormMGExceptDraftState
  | LoadFormMGExceptDraftStateSuccess
  | LoadFormMGPendingApprovalState
  | LoadFormMGPendingApprovalStateSuccess
  | LoadFormMGApprovedState
  | LoadFormMGApprovedStateSuccess

  | LoadFormCGExceptDraftState
  | LoadFormCGExceptDraftStateSuccess
  | LoadFormCGPendingApprovalState
  | LoadFormCGPendingApprovalStateSuccess
  | LoadFormCGApprovedState
  | LoadFormCGApprovedStateSuccess

  | LoadFormESExceptDraftState
  | LoadFormESExceptDraftStateSuccess
  | LoadFormESPendingApprovalState
  | LoadFormESPendingApprovalStateSuccess
  | LoadFormESApprovedState
  | LoadFormESApprovedStateSuccess

  | LoadFormPPExceptDraftState
  | LoadFormPPExceptDraftStateSuccess
  | LoadFormPPPendingApprovalState
  | LoadFormPPPendingApprovalStateSuccess
  | LoadFormPPApprovedState
  | LoadFormPPApprovedStateSuccess;